import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-highlighted-network-measurements',
    templateUrl: './highlighted-network-measurements.component.html',
    standalone: false
})
export class HighlightedNetworkMeasurementsComponent {
  @Input() category: string = 'warning';

  @Input() dataUtilization: string = '0';

  @Input() latency: string = '0';

  @Input() jitter: string = '0';

  @Input() packetLost: string = '0';
}
